import React from 'react';
import { Field, reduxForm, formValueSelector, initialize } from 'redux-form';
import { Form, Button } from 'react-bootstrap';
import { Input } from '../../common/components/formControls';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			<Field name='query' component={Input} horizontal disabled={isReadonly} type='text' placeholder={`${t('Common_Search')}`} labelCol={0} valueCol={12} formGroupStyle={{ marginBottom: 0 }}
				action={<Button type='submit' bsStyle='default' disabled={submitting}><FontAwesomeIcon icon={faSearch} /></Button>} />
		</Form>
	);
};

export default reduxForm({ form: 'notesFilter', enableReinitialize: true })(withTranslation()(SettingsForm));

export const selector = formValueSelector('notesFilter');
export const initializeForm = (data, fields) => initialize('notesFilter', data, fields);
